const CONSENT_KEY = 'gradevit-consent';

export function getConsentStatus() {
  return localStorage.getItem(CONSENT_KEY);
}

export function setConsentStatus(value) {
  localStorage.setItem(CONSENT_KEY, value);
}
